/** A compact rounded chip for one amount (net / VAT / gross). Shared by the invoice detail view and
 * the composer so both render the totals the same way. */
export function AmountPill({ label, value }: { label: string; value: string }) {
  return (
    <div className="inline-flex items-baseline gap-2 rounded-full border bg-card px-4 py-1.5 text-sm">
      <span className="text-muted-foreground">{label}</span>
      <span className="font-medium tabular-nums">{value}</span>
    </div>
  );
}
